var FileDownload = require("js-file-download");
var moment = require("moment");
export const SET_GASTEN_VERBRUIK = "SET_GASTEN_VERBRUIK";
export const ADD_GASTEN_VERBRUIK = "ADD_GASTEN_VERBRUIK";
export const GASTEN_VERBRUIK_ERROR = "GASTEN_VERBRUIK_ERROR";
export const SET_GAST_VERBRUIK = "SET_GAST_VERBRUIK";
export const SET_VERBRUIK = "SET_VERBRUIK";
export const SET_GASTS = "SET_GASTS";
export const SET_GAST = "SET_GAST";
export const SET_TIPS = "SET_TIPS";
export const SET_TIP = "SET_TIP";
export const SET_GASTEN_PROFIEL = "SET_GASTEN_PROFIEL";
export const GET_GASTEN_PROFIEL = "GET_GASTEN_PROFIEL";
export const SET_ARTIKELEN = "SET_ARTIKELEN";
export const SET_ARTIKEL = "SET_ARTIKEL";
export const ARTIKEL_ERROR = "ARTIKEL_ERROR";
export const DELETE_GASTEN_VERBRUIK = "DELETE_GASTEN_VERBRUIK";
export const SET_ACTIVITY_LOGS = "SET_ACTIVITY_LOGS";
export const ACTIVITY_LOGS_LOADING = "ACTIVITY_LOGS_LOADING";
export const ACTIVITY_LOGS_ERROR = "ACTIVITY_LOGS_ERROR";
export const SET_ALL_ACTIVITY_LOGS = "SET_ALL_ACTIVITY_LOGS";
export const ALL_ACTIVITY_LOGS_LOADING = "ALL_ACTIVITY_LOGS_LOADING";
export const ALL_ACTIVITY_LOGS_ERROR = "ALL_ACTIVITY_LOGS_ERROR";
export const SET_ELECTRICITY_DATA = "SET_ELECTRICITY_DATA";
export const ELECTRICITY_DATA_LOADING = "ELECTRICITY_DATA_LOADING";
export const ELECTRICITY_DATA_ERROR = "ELECTRICITY_DATA_ERROR";
export const SET_KAMPEERPLAATSEN = "SET_KAMPEERPLAATSEN";
export const KAMPEERPLAATSEN_LOADING = "KAMPEERPLAATSEN_LOADING";
export const KAMPEERPLAATSEN_ERROR = "KAMPEERPLAATSEN_ERROR";
export const SET_REPORTS = "SET_REPORTS";
export const REPORTS_LOADING = "REPORTS_LOADING";
export const REPORTS_ERROR = "REPORTS_ERROR";
export const REPORT_SAVED = "REPORT_SAVED";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    return response.json().then((errorData) => {
      let error = new Error(response.statusText);
      error.data = errorData.errors;
      throw error;
    });
  }
}

function handleDownload(response) {
  if (response.ok) {
    return response.blob();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

export function set(results) {
  return {
    type: SET_GASTEN_VERBRUIK,
    results,
  };
}

export function get(results) {
  return {
    type: SET_GAST_VERBRUIK,
    results,
  };
}

export function setstam(results) {
  return {
    type: SET_GAST,
    results,
  };
}

export function getstam(results) {
  return {
    type: SET_GASTS,
    results,
  };
}

export function setverbruik(results) {
  return {
    type: SET_VERBRUIK,
    results,
  };
}

export function setone(results) {
  return {
    type: SET_GAST_VERBRUIK,
    results,
  };
}
export function add(results) {
  return {
    type: ADD_GASTEN_VERBRUIK,
    results,
  };
}

export function gettip(results) {
  return {
    type: SET_TIP,
    results,
  };
}

export function settips(results) {
  return {
    type: SET_TIPS,
    results,
  };
}

export function itemError(error) {
  return {
    type: GASTEN_VERBRUIK_ERROR,
    error,
  };
}

export function setgastenprofiel(results) {
  return {
    type: SET_GASTEN_PROFIEL,
    results,
  };
}

export function getgastenprofiel(results) {
  return {
    type: GET_GASTEN_PROFIEL,
    results,
  };
}

export function addgastengebruik(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      dispatch(add(results));
      return true;
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fetchgastenverbruik(query) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik?" + query, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(set(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fetchgastenverbruikone(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(get(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function deletegastverbruik(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/" + id, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(get(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function updategastengebruik(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(get(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function addgasten(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fetchasten() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(getstam(results.results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fetchonegasten(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results.result));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function updategasten(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results.results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fechduurzaamtips() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(settips(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fechoneduurzaamtips(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(gettip(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function inserteduurzaamtips(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips/", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(gettip(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function updateeduurzaamtips(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/duurzaamtips/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(gettip(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function addgastenprofiel(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(setgastenprofiel(results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function fechgastenprofiel() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(getgastenprofiel(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fechonegastenprofiel(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setgastenprofiel(results.results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function updategastenprofiel(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(getgastenprofiel(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function copygastenprofiel(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/gastenprofiel/copy", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setgastenprofiel(results));
    } catch (err) {
      return dispatch(itemError(err));
    }
  };
}

export function addgastengebruikmeter(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/meter", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function finishedboeking(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function addwkhboeking(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/addkwh/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function verplaatsboeking(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/verplaatsboeking/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function fetchonemetreservering(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/metreservering/" + id, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      const results = await handleResponse(response);
      return dispatch(setstam(results.result));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function changedatedepart(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/changedatedepart/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function uploadgasten(data) {
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("file", data.excel); // "file" is de key die je backend verwacht
      formData.append("gastenprofiel", data.gastenprofiel);
      

      const response = await fetch("/api/admin/stamgegevens/upload/", {
        method: "POST",
        body: formData,
        headers: {
          Authorization: localStorage.getItem("token"),
          // Let op: GEEN "Content-Type" hier, browser stelt automatisch multipart boundary in
        },
      });

      const results = await handleResponse(response);
      return dispatch(getstam(results));
    } catch (err) {
      return dispatch(itemError(err));
    }
  };
}

export function deletegast(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/" + id, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      return dispatch(getstam(results));
    } catch (err) {
      // Hier kun je meer gedetailleerde informatie uit err.data halen, indien beschikbaar
      return dispatch(itemError(err));
    }
  };
}

export function exportExcel(query) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/excel?"+query, {
        method: "get",

        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const blob = await handleDownload(response);
      const filename = `export_${moment().format("YYYYMMDD_HH:mm")}.xlsx`;
      FileDownload(blob, filename);
    } catch {
      dispatch(itemError("Bad Login Info"));
    }
  };
}

export function changeampere(id, data) {
    return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/boeking/changeampere/" + id, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(add(results));
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het insert database"));
    }
  };
}

export function deleteReservering(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/reservering/" + id, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      dispatch({
        type: DELETE_GASTEN_VERBRUIK,
        id: id
      });
      return results;
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het verwijderen van de reservering"));
    }
  };
}

export function activeerReservering(id) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/stamgegevens/activeren/" + id, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      dispatch(setone(results.results));
      return results;
    } catch (err) {
      return dispatch(itemError("Er is een fout opgetreden bij het activeren van de reservering"));
    }
  };
}

// Artikelen Actions
export function setArtikelen(results) {
  return {
    type: SET_ARTIKELEN,
    results,
  };
}

export function setArtikel(results) {
  return {
    type: SET_ARTIKEL,
    results,
  };
}

export function artikelError(error) {
  return {
    type: ARTIKEL_ERROR,
    payload: error,
  };
}

export function fetchArtikelen() {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/artikelen", {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikelen(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het ophalen van artikelen"));
    }
  };
}

export function fetchOneArtikel(id) {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/admin/gastenverbruik/artikelen/${id}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikel(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het ophalen van het artikel"));
    }
  };
}

export function addArtikel(data) {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/admin/gastenverbruik/artikelen", {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikel(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het toevoegen van het artikel"));
    }
  };
}

export function updateArtikel(id, data) {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/admin/gastenverbruik/artikelen/${id}`, {
        method: "put",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      const results = await handleResponse(response);
      return dispatch(setArtikel(results.results));
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het bijwerken van het artikel"));
    }
  };
}

export function deleteArtikel(id) {
  return async (dispatch) => {
    try {
      const response = await fetch(`/api/admin/gastenverbruik/artikelen/${id}`, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });
      await handleResponse(response);
      return dispatch(fetchArtikelen());
    } catch (err) {
      return dispatch(artikelError("Er is een fout opgetreden bij het verwijderen van het artikel"));
    }
  };
}

// Activity Logs Actions
export function setActivityLogs(logs) {
  return {
    type: SET_ACTIVITY_LOGS,
    logs,
  };
}

export function activityLogsLoading(loading) {
  return {
    type: ACTIVITY_LOGS_LOADING,
    loading,
  };
}

export function activityLogsError(error) {
  return {
    type: ACTIVITY_LOGS_ERROR,
    error,
  };
}

export function fetchActivityLogs(gastenverbruikId) {
  return async (dispatch) => {
    try {
      dispatch(activityLogsLoading(true));
      dispatch(activityLogsError(null));

      const response = await fetch(`/api/admin/gastenverbruik/${gastenverbruikId}/activities`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      dispatch(setActivityLogs(results.results || []));
      return results;
    } catch (err) {
      dispatch(activityLogsError("Er is een fout opgetreden bij het ophalen van de activity logs"));
      throw err;
    } finally {
      dispatch(activityLogsLoading(false));
    }
  };
}

// All Activity Logs Actions
export function setAllActivityLogs(logs) {
  return {
    type: SET_ALL_ACTIVITY_LOGS,
    logs,
  };
}

export function allActivityLogsLoading(loading) {
  return {
    type: ALL_ACTIVITY_LOGS_LOADING,
    loading,
  };
}

export function allActivityLogsError(error) {
  return {
    type: ALL_ACTIVITY_LOGS_ERROR,
    error,
  };
}

export function fetchAllActivityLogs(filters = {}) {
  return async (dispatch) => {
    try {
      dispatch(allActivityLogsLoading(true));
      dispatch(allActivityLogsError(null));

      // Build query params from filters
      const queryParams = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          queryParams.append(key, filters[key]);
        }
      });

      const queryString = queryParams.toString();
      const url = `/api/admin/gastenverbruik/activities/all${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      dispatch(setAllActivityLogs(results.results || []));
      return results;
    } catch (err) {
      dispatch(allActivityLogsError("Er is een fout opgetreden bij het ophalen van alle activity logs"));
      throw err;
    } finally {
      dispatch(allActivityLogsLoading(false));
    }
  };
}

// Electricity Data Action Creators
export function setElectricityData(data) {
  return {
    type: SET_ELECTRICITY_DATA,
    data
  };
}

export function electricityDataLoading(loading) {
  return {
    type: ELECTRICITY_DATA_LOADING,
    loading
  };
}

export function electricityDataError(error) {
  return {
    type: ELECTRICITY_DATA_ERROR,
    error
  };
}

// Kampeerplaatsen Action Creators
export function setKampeerplaatsen(kampeerplaatsen) {
  return {
    type: SET_KAMPEERPLAATSEN,
    kampeerplaatsen
  };
}

export function kampeerplaatsenLoading(loading) {
  return {
    type: KAMPEERPLAATSEN_LOADING,
    loading
  };
}

export function kampeerplaatsenError(error) {
  return {
    type: KAMPEERPLAATSEN_ERROR,
    error
  };
}

// Electricity Analysis Thunk Actions
export function fetchElectricityData(filters = {}) {
  return async (dispatch) => {
    try {
      console.log('🔌 fetchElectricityData called with filters:', filters);
      dispatch(electricityDataLoading(true));
      dispatch(electricityDataError(null));

      // Build query params from filters
      const queryParams = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          if (Array.isArray(filters[key])) {
            filters[key].forEach(value => queryParams.append(key, value));
          } else {
            queryParams.append(key, filters[key]);
          }
        }
      });

      const queryString = queryParams.toString();
      const url = `/api/admin/gastenverbruik/elektriciteitsanalyse/data${queryString ? `?${queryString}` : ''}`;

      console.log('🌐 Fetching electricity data from URL:', url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      console.log('📡 Response status:', response.status);

      const results = await handleResponse(response);
      console.log('📊 Electricity data received:', results);

      dispatch(setElectricityData(results));
      return results;
    } catch (err) {
      dispatch(electricityDataError("Er is een fout opgetreden bij het ophalen van elektriciteitsdata"));
      throw err;
    } finally {
      dispatch(electricityDataLoading(false));
    }
  };
}

export function fetchKampeerplaatsen() {
  return async (dispatch) => {
    try {
      dispatch(kampeerplaatsenLoading(true));
      dispatch(kampeerplaatsenError(null));

      const response = await fetch("/api/admin/standplaatsen/kampeerplaatsen/all", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const data = await handleResponse(response);
      const results = data.results || data; // Handle both { results: [] } and direct array
      dispatch(setKampeerplaatsen(results));
      return results;
    } catch (err) {
      dispatch(kampeerplaatsenError("Er is een fout opgetreden bij het ophalen van kampeerplaatsen"));
      throw err;
    } finally {
      dispatch(kampeerplaatsenLoading(false));
    }
  };
}

// Reports Action Creators
export function setReports(reports) {
  return {
    type: SET_REPORTS,
    reports
  };
}

export function reportsLoading(loading) {
  return {
    type: REPORTS_LOADING,
    loading
  };
}

export function reportsError(error) {
  return {
    type: REPORTS_ERROR,
    error
  };
}

export function reportSaved(report) {
  return {
    type: REPORT_SAVED,
    report
  };
}

// Reports Thunk Actions
export function saveReport(reportData) {
  return async (dispatch) => {
    try {
      dispatch(reportsLoading(true));
      dispatch(reportsError(null));

      const response = await fetch("/api/admin/gastenverbruik/elektriciteitsanalyse/reports", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify(reportData),
      });

      const result = await handleResponse(response);
      dispatch(reportSaved(result));
      return result;
    } catch (err) {
      dispatch(reportsError("Er is een fout opgetreden bij het opslaan van het rapport"));
      throw err;
    } finally {
      dispatch(reportsLoading(false));
    }
  };
}

export function fetchReports() {
  return async (dispatch) => {
    try {
      dispatch(reportsLoading(true));
      dispatch(reportsError(null));

      const response = await fetch("/api/admin/gastenverbruik/elektriciteitsanalyse/reports", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      const results = await handleResponse(response);
      dispatch(setReports(results));
      return results;
    } catch (err) {
      dispatch(reportsError("Er is een fout opgetreden bij het ophalen van rapporten"));
      throw err;
    } finally {
      dispatch(reportsLoading(false));
    }
  };
}
